export default "__VITE_ASSET__DHv7XIIB__"